// extracted by mini-css-extract-plugin
export default {"changelogcontainer":"DashboardPage_changelogcontainer__Fgi0e","changelogbutton":"DashboardPage_changelogbutton__Wiby7","logo":"DashboardPage_logo__hlJUj"};